import {
  IsUUID,
  IsInt,
  IsPositive,
  IsBoolean,
  IsString,
  IsOptional,
  ValidateIf
} from "class-validator";
import { Type } from "class-transformer";

import TestQuestion from "./question";
import TestAnswerVersion from "./answer_version";

export default class TestQuestionVersion {
  @IsUUID("4")
  public readonly id!: string;

  @IsOptional()
  @IsString()
  public title: string = "";

  @IsInt()
  @IsPositive()
  public version: number = 1;

  @IsInt()
  @IsPositive()
  public position: number = 1;

  @IsBoolean()
  public use_image: boolean = false;

  @IsOptional()
  @IsString()
  @ValidateIf(o => o.use_image)
  public image_url?: string | null;

  @Type(() => TestQuestion)
  public question: TestQuestion = new TestQuestion();

  @Type(() => TestAnswerVersion)
  public answer_versions: TestAnswerVersion[] = [];

  public is_correct?: boolean;
  public is_answered?: boolean;

  constructor(data?: any) {
    if (data) {
      if (typeof data.title === "string") {
        this.title = data.title;
      }

      if (typeof data.version === "number") {
        this.version = data.version;
      }

      if (typeof data.position === "number") {
        this.position = data.position;
      }
    }
  }

  public get isSingle() {
    return this.question.type === "SINGLE";
  }

  public get isMultiple() {
    return this.question.type === "MULTIPLE";
  }
}
